export const isAnyFilterEnabled = (filters: object): boolean =>
  Object.values(filters).filter((it) => !!it).length > 0;
